import React from 'react';
import UserTokenService from '../../../../../../assets/editor/js/services/UserTokenService';
import FilemanagerService from '@assets/services/FilemanagerService';

const filemanagerService = new FilemanagerService();
const userTokenService = new UserTokenService();

class FileUploadBlock extends React.Component {
    constructor(props) {
        super(props);
        this.uploadBtn = React.createRef();
        let data = {
            rowId: this.props.rowId,
            tableId: this.props.tableId,
            fieldName: this.props.fieldName
        };
        this.state = {
            data: data,
        };
    }

    onchange() {
        return userTokenService.getToken()
            .then((token) => {
                const filemanagerDomain = filemanagerService.getDomain();
                const data = {
                    ...this.state.data,
                    token,
                };
                $(this.uploadBtn.current).upload(filemanagerDomain + 'files', data, (res) => {
                    this.props.setNewFiles(res);
                    this.props.createNewUpdate();
                });
            });
    }

    render() {
        return (
            <div className="row">
                <div className="col-md-4">
                    <label>Загрузить файлы</label>
                    <input id='userfile' type="file" min="1" max="500" name="file[]" multiple
                           onChange={(e) => {
                               this.onchange(e)
                           }} ref={this.uploadBtn}/>
                </div>
                <div className="col-md-8" role="alert">
                    <div className="alert alert-danger hide" role="alert" id="file-errors"/>
                    <div className="alert alert-danger hide" role="alert" id="alert-error">
                        Файл с таким названием уже загружен в систему.
                        Чтобы его заменить новым файлом, отметьте галочку. Либо измените название файла.
                    </div>
                    <div className="alert alert-danger hide" role="alert" id="alert-error-dublicate">
                        Название файла занято. Выберите другое название.
                    </div>
                </div>
            </div>
        );
    }
}
export default FileUploadBlock;
